// extracted by mini-css-extract-plugin
module.exports = {"anchorSectionContainer":"Q_b6","allArticlesAnchorToSection":"Q_b7","mobileLink":"Q_b8"};